import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";

interface IValorantInfoAreaHeadlineProps {
  children: string;
}

const ValorantInfoAreaHeadline: React.FC<IValorantInfoAreaHeadlineProps> = ({
  children,
}) => {
  return (
    <SSHeadline
      props={{
        title: {
          className: "break-words font-secret-black text-center vertial-center",
        },
      }}
    >
      <Emoji.Pin /> <SSWhiteText>{children}</SSWhiteText>
    </SSHeadline>
  );
};

export default ValorantInfoAreaHeadline;
